// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const RadarInfoTooltip: MarkdocTagRegistration = {
  tag: 'radar-info-tooltip',
  component: 'RadarInfoTooltip',
  attributes: {
    text: {
      type: String,
      localizable: true,
    },
  },
};
